import React from "react";
import Button from "../../../../component/button/Button";
import { useSelector } from "react-redux";
import useClientConfig from "../../../../config/careers/clientConfig";
import ShareJob from "../OptionThree/ShareJob";


const PremimumNoJobMatch = (props: any) => {
    const questionId = useSelector((stete: any) => { return stete?.careers?.getQuestionId; });
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const noJobLang = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const noJobLangLabels = noJobLang?.noJobsSection?.[0];
    const { clientAssetsLink } = useClientConfig();

    const { navigateToJob, navigateToJobAlerts, routeParams, location, langLabels } = props;

    return (
        <>
            {(questionId?.status === 200 || cliendConfig?.data?.data?.clientSettings?.showJobAlertButton === 1) ? (

                <div className={"job-search-box "}>
                    <div className="pt-njm-main">
                        <div className="btn-section pt-njm-left">
                            <div className="pt-njm-copy">
                            <h2 className="job-view-text">{noJobLangLabels?.noJobs}</h2>
                            <p className="infi-text" dangerouslySetInnerHTML={{ __html: noJobLangLabels?.noJobsText }} ></p>
                        </div>
                        <div className="premimum-tem-bottum pt-njm-actions">
                            {questionId?.status === 200 || cliendConfig?.data?.data?.clientSettings?.registerYourInterestButtonText ?
                                <Button
                                    clasName="btn-new btn-primary-new w-100 justify-content-center pt-njm-btn pt-njm-interest"
                                    label={
                                        cliendConfig?.data?.data?.clientSettings?.registerYourInterestButtonText
                                        || noJobLangLabels?.registerYourInterest
                                    }
                                    onClick={navigateToJob} />
                                : ""}

                            {(cliendConfig?.data?.data?.clientSettings?.showJobAlertButton === 1) ? (
                                <Button
                                    clasName="btn-new btn-primary-new w-100 justify-content-center pt-njm-btn pt-njm-alert"
                                    label={
                                        cliendConfig?.data?.data?.clientSettings?.jobAlertButtonText
                                        || noJobLangLabels?.jobAlerts
                                    }
                                    onClick={navigateToJobAlerts} />
                            ) : ""}
                        </div>
                        </div>

                    </div>
                    <div className="pt-njm-share">
                        <ShareJob cliendConfig={cliendConfig} routeParams={routeParams} location={location} />
                    </div>
                </div>

            ) : ""}

            {(cliendConfig?.data?.data?.clientSettings?.clientSiteSettings?.templateName === "template_30") && <div className="bestEmployer"><img src={clientAssetsLink + "/best_employer.png"} /></div>}
        </>
    );
};

export default PremimumNoJobMatch;
